import { BasketErrorModel } from './BasketErrorModel';
import { BasketApiErrorModel } from './BasketApiErrorModel';

export class BasketPaymentErrorModel extends BasketErrorModel {
    public code: string | null;

    constructor(message: string, code?: string, source?: string, innerError?: BasketApiErrorModel) {
        super(message, undefined, source, [{ key: 'code', value: code ?? null }], innerError);

        this.code = code ?? null;
    }
}